/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Merge_GroupsInputs */

const en_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Groups`)
};

const fr_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner les groupes`)
};

const de_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppen zusammenführen`)
};

const it_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci gruppi`)
};

const ru_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение групп`)
};

const es_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar grupos`)
};

const zh_cn2_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并群组`)
};

const ja_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループの結合`)
};

const hi_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूहों को मर्ज करें`)
};

const pt_pt2_event_group_options_merge_groups = /** @type {(inputs: Event_Group_Options_Merge_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unir grupos`)
};

/**
* | output |
* | --- |
* | "Merge Groups" |
*
* @param {Event_Group_Options_Merge_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_groups = /** @type {((inputs?: Event_Group_Options_Merge_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_merge_groups(inputs)
	if (locale === "de") return de_event_group_options_merge_groups(inputs)
	if (locale === "it") return it_event_group_options_merge_groups(inputs)
	if (locale === "ru") return ru_event_group_options_merge_groups(inputs)
	if (locale === "es") return es_event_group_options_merge_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_merge_groups(inputs)
	if (locale === "ja") return ja_event_group_options_merge_groups(inputs)
	if (locale === "hi") return hi_event_group_options_merge_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_merge_groups(inputs)
	return en_event_group_options_merge_groups(inputs)
});